import { lazy, Suspense } from "react";
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";

const CandidatesManagment = lazy(() =>
  import("@/features/candidatesManagment/pages/CandidatesManagment")
);
const TalentPoolDetails = lazy(() =>
  import("@/features/candidatesManagment/pages/TalentPoolDetails")
);

export const candidateRoutes = [
  {
    path: "/candidates-managment",
    element: (
      <Suspense fallback={<LoadingFeedback />}>
        <CandidatesManagment />
      </Suspense>
    ),
  },
  {
    path: "/talent-pools/:id",
    element: (
      <Suspense fallback={<LoadingFeedback />}>
        <TalentPoolDetails />
      </Suspense>
    ),
  },
];
